/**
 * @desc 导出供应商信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierInfo.exportSupplierInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/export/supplierInfo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
